export default function GroupOrEventHeading({
  imageSrc,
  title,
  subtitle,
}: {
  imageSrc: string | undefined;
  title: string;
  subtitle?: string;
}) {
  return (
    <div className="flex gap-x-5 items-start">
      {imageSrc && (
        <div className="w-[232px] shrink-0 h-[138px] flex border rounded-4xl border-purple-100 bg-purple-10">
          <img src={imageSrc} className="max-w-[164px] m-auto" alt="" />
        </div>
      )}
      <div className="flex flex-col py-1.5 gap-y-0.5">
        <h5 className="text-sm-bold">{title}</h5>
        {subtitle && (
          <p className="text-black-400 text-xs-medium">{subtitle}</p>
        )}
      </div>
    </div>
  );
}
